import _ from 'lodash';
import React from 'react';

import TagInput from 'shared/components/TagInput';

import styles from './styles.module.scss';

const renderTagInput = ({
  input,
  input: { name },
  type,
  placeholder,
  disabled,
  dataTest,
  formErrors,
  handleChange,
  meta,
  meta: { touched, error, warning },
  ...rest
}) => {
  const inputValue = input.value;
  input = { ...input, value: _.isArray(inputValue) ? inputValue : [] };

  let errorsArray = [];

  touched &&
    !_.isNil(error) &&
    !_.isEmpty(error) &&
    _.forEach(error, (errorValue, key) => {
      errorsArray = errorsArray.concat(errorValue);
    });

  return (
    <div>
      <TagInput
        disabled={disabled}
        data-test={dataTest}
        inputProps={{ name, placeholder }}
        {...input}
        {...rest}
      />

      {!_.isEmpty(errorsArray) &&
        errorsArray.map(message => (
          <div className={styles.error}>{message}</div>
        ))}
    </div>
  );
};

export default renderTagInput;
